import { h } from "preact";
import { useState, useRef } from "preact/hooks";
import GiftCardRecipientTriggerContent from "./gift-card-recipient-form-trigger-content";

export default function GiftCardRecipientTrigger({
  idPrefix,
  isGift,
  setIsGift,
  recipientData,
  setRecipientData,
  recipientErrors,
  resetRecipientErrors,
}) {
  const buttonRef = useRef();

  return (
    <div className="gift-card-recipient-form">
      <label className="gift-card-recipient-form__checkbox-input-wrapper">
        <div className="checkbox-wrapper">
          <input
            type="checkbox"
            className="gift-card-recipient-form__checkbox-input"
            name="send_giftcard_as_gift"
            checked={isGift}
            onChange={() => {
              setIsGift(!isGift);
              resetRecipientErrors();
            }}
            ref={buttonRef}
          />
          <span className="checkbox-icon"></span>
        </div>
        <span className="gift-card-recipient-form__checkbox-input-text body-2">
          {window.localeStrings.giftCardRecipientForm.checkbox}
        </span>
      </label>
      <GiftCardRecipientTriggerContent
        idPrefix={idPrefix}
        open={isGift}
        recipientData={recipientData}
        setRecipientData={setRecipientData}
        recipientErrors={recipientErrors}
      />
    </div>
  );
}
